import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { updateDailyTaskRewards } from "../../store/dailyTaskReward/action";
import { permissionError } from "../../util/Alert";

const DailyTaskRewardDialog = ({ task, onClose }) => {
  const dispatch = useDispatch();
  const hasPermission = useSelector((state) => state.admin.admin.flag);
  const [points, setPoints] = useState(task.points == null ? "" : String(task.points));
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!hasPermission) return permissionError();
    const value = points.trim() === "" ? null : Number(points);
    if (value !== null && (!Number.isSafeInteger(value) || value < 1)) {
      return setError("Enter a positive whole number, or leave blank to make this task inactive.");
    }
    setSaving(true);
    const saved = await dispatch(updateDailyTaskRewards(task._id, value));
    setSaving(false);
    if (saved) onClose();
  };

  return (
    <Dialog open={Boolean(task)} onClose={onClose} fullWidth maxWidth="sm"
      PaperProps={{ style: { backgroundColor: "#161622", color: "#fff" } }}>
      <DialogTitle disableTypography style={{ color: "#fff", fontSize: "1.25rem", fontWeight: 500, lineHeight: 1.6 }}>
        Configure Vibe Pass Points
      </DialogTitle>
      <DialogContent>
        <h5 className="text-danger">{task.title}</h5>
        <p>{task.description}</p>
        <label className="form-label" htmlFor="task-points">Points on completion</label>
        <input id="task-points" className="form-control" type="number" min="1" step="1"
          value={points} onChange={(event) => setPoints(event.target.value)}
          placeholder="Leave blank to make task inactive" />
        {error && <div className="text-danger mt-2">{error}</div>}
        <div className="d-flex justify-content-end gap-3 my-4">
          <button className="btn btn-secondary" type="button" onClick={onClose}>Cancel</button>
          <button className="btn btn-danger" type="button" onClick={save} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DailyTaskRewardDialog;
